import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import LandingPage from "@/pages/LandingPage";
import RegisterPage from "@/pages/RegisterPage";
import PaymentResultPage from "./pages/PaymentResultPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/tanitim" replace />} />
          <Route path="/tanitim" element={<LandingPage />} />
          <Route path="/tanitim/kayit" element={<RegisterPage />} />
          <Route path="/tanitim/odeme-sonuc" element={<PaymentResultPage />} />
          <Route path="*" element={<Navigate to="/tanitim" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
